import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Lottie from 'react-lottie';

import heroOrbs from '../assets/heroOrbs.png';
import fourWomen from '../assets/fourWomen.json';
import projectHealthLogoM from '../assets/projectHealthLogoM.svg';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    backgroundImage: `url(${heroOrbs})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  fourWomen: {
    // width: '75vw',
    marginTop: '5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '4rem'
    }
  },
  textCont: {
    width: '53rem',
    textAlign: 'center',
    marginTop: '2rem',
    [theme.breakpoints.down('sm')]: {
      width: '17rem'
    }
  },
  heroHeader: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '3.4rem'
    }
  },
  heroPara: {
    marginTop: '2rem',
    [theme.breakpoints.down('sm')]: {
      //   width: '18.5rem',
      fontSize: '1.125rem'
    }
  },
  phLogo: {
    position: 'absolute',
    zIndex: 3,
    top: '130px',
    left: '50px',
    width: '12%',
    [theme.breakpoints.down('sm')]: {
      width: '20%',
      top: '80px',
      left: '20px'
    }
  }
}));

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: fourWomen,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const Hero = () => {
  const classes = useStyles();
  return (
    <>
      <img src={projectHealthLogoM} alt="project health logo" className={classes.phLogo} />
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className={classes.container}
      >
        <Grid item className={classes.fourWomen}>
          <Lottie options={defaultOptions} />
        </Grid>
        <Grid item className={classes.textCont}>
          <Typography variant="h1" className={classes.heroHeader}>
            Catalysts of Change
          </Typography>
          <Typography variant="h5" className={classes.heroPara}>
            Black and Hispanic women are dying of cancer at alarming rates. What can be done to
            change course?
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default Hero;
